var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1L1 8.5M1 8.5H22.5M1 8.5L8 16",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 9.59865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/arrow_left.38e54e37.svg";
export { SvgComponent as ReactComponent };